import type React from 'react';

import { Alert } from '@change/ds-core-ui';

const DeleteSuccessMessage: React.FC = () => {
	return (
		<Alert variant="success" heading="Success" className="mb-2">
			Video Successfully removed.
		</Alert>
	);
};

const DeleteErrorMessage: React.FC = () => {
	return (
		<Alert variant="warning" heading="Delete failed" className="mb-2">
			Something went wrong while deleting.
		</Alert>
	);
};

export const PetitionVideoDeleteMessage: React.FC<{
	message: 'success' | 'error' | undefined;
}> = ({ message }) => {
	if (message === 'success') return <DeleteSuccessMessage />;
	if (message === 'error') return <DeleteErrorMessage />;
	return null;
};
